import { JSMOverlayTemplate } from "@/components/signup/layouts/product-overlay-template";
import { SignupBackgroundLayout } from "@/components/signup/layouts/signup-background-layout";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils/logos/service-collection-logo";
import { ExperimentView } from "@/utils/experiment/experiment-view";
import { experiments } from "@/utils/experiment/manifest";

import { CreateAWorkspaceText } from "../components/create-a-workspace-heading";
import { Headings } from "../components/headings";
import { WorkspacesAreWhereText } from "../components/sub-heading";

const NewUserContent = () => {
    return (
        <>
            <Headings
                main={<CreateAWorkspaceText />}
                sub={<WorkspacesAreWhereText />}
            />
            <SiteActivation />
        </>
    );
};

export const NewUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        // @ts-ignore
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <NewUserContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <NewUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
